import Link from 'next/link';
import cn from 'classnames';
import styles from './index.module.scss';
import HopLogo from '@/components/Svgs/hoplogo';

const PuntosHopBtn = ({ text, locale }) => {
  return (
    <Link
      href="/conoce-los-puntos-hop"
      className={cn('flex items-center relative', styles.conoceButton)}
      locale={locale}
      aria-label={`${text} - Conocer los puntos HOP`}
    >
      <div
        className={cn(
          styles.shadow,
          styles.circleRed,
          'relative z-1 w-37 h-37 bg-red rounded-full mr-6'
        )}
      >
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-17">
          <HopLogo />
        </div>
      </div>
      <div className={cn(styles.textPill, 'rounded-full px-10 -translate-x-10')}>
        <p className="p3 !leading-[3] !font-medium text-black opacity-60 uppercase whitespace-nowrap">{text}</p>
      </div>
    </Link>
  );
};
export default PuntosHopBtn;
